import * as Yup from 'yup';

export default Yup.object().shape({
  fullName: Yup.string().required('Full Name is required').max(250),
  email: Yup.string().email('Please enter valid email address').required('Email Address is required').max(250),
  phone: Yup.string().max(20),
  isActive: Yup.bool().nullable()
});